import { DEDICATED_COMMON_PARAMS, ORDER_TYPE, PRODUCT_NAME, PRODUCT_TYPE, USER_TYPE } from 'common/constants/app.constants';
import { getFromSessionStorage, removeUserSessionData, setInSessionStorage } from 'common/utils/app.utils';
import { FEASIBILITY_STATUS_UNAUTH, MODULE_ID, SELECTED_PARTY_ACCOUNT } from 'home/common/constants/constants';
import {
  AUTH_TOKEN,
  CART_STATUS,
  FEASIBILITY_SUCCESS,
  LEAD_ID,
  MULTI_SITE_MODULE_ID,
  MULTI_SITE_TABLE_EDITED,
  SITE_READINESS_TABLE_EDITED
} from 'home/view/manage-feasibility/constants';
import queryString from 'query-string';

export const updateProductInfo = () => {
  const getParams = queryString.parse(window && window.location.search);
  if (getParams) {
    if (getParams.productType) {
      setInSessionStorage(MODULE_ID, PRODUCT_NAME, getParams.productType);
    }
    if (getParams.partyId) {
      setInSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT, getParams.partyId);
    }
  }
  const savedProductType = getFromSessionStorage(MODULE_ID, PRODUCT_NAME);
  if (!savedProductType) {
    setInSessionStorage(MODULE_ID, PRODUCT_NAME, getParams && getParams.productType ? getParams.productType : PRODUCT_TYPE.DEDICATED_INTERNET);
  }
  const updatedProductType = getFromSessionStorage(MODULE_ID, PRODUCT_NAME);
  DEDICATED_COMMON_PARAMS.serviceType = getParams && getParams.productType ? getParams.productType : updatedProductType;
};

export const saveUser = (user) => {
  const loggedInUserType = user ?? 'CUSTOMER';
  setInSessionStorage(MODULE_ID, USER_TYPE, loggedInUserType);
};

export const saveLeadId = (leadId) => {
  if (leadId) {
    setInSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID, leadId);
  }
};

export const removeUserData = (source) => {
  if (source === 'AEH_site') {
    removeUserSessionData();
  }
};

export const setMultiSiteSessionData = (auth_token) => {
  setInSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN, auth_token);
  getFromSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID, true);
  getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_STATUS, true);
  getFromSessionStorage(MULTI_SITE_MODULE_ID, FEASIBILITY_SUCCESS, true);
  getFromSessionStorage(MULTI_SITE_MODULE_ID, MULTI_SITE_TABLE_EDITED, true);
  // getFromSessionStorage(MULTI_SITE_MODULE_ID, SITE_READINESS_TABLE_EDITED, true);
};

export const isOrderTypeConfirmation = (type) => {
  return type === ORDER_TYPE.ORDER_CONFIRMATION;
};

export const trackScrolling = () => {
  window.addEventListener('scroll', () => {
    const subHeaderElem = document.getElementsByClassName('b2b-lib-subHeader');
    if (subHeaderElem && subHeaderElem[0]) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 5) {
        subHeaderElem[0].style.display = 'none';
      } else {
        subHeaderElem[0].style.display = 'block';
      }
    }
  });
};

export const trackGTM = (event, virtualPagename) => {
  dataLayer.push({ event: event ? event : 'SPAPV', virtualPagename: virtualPagename ? virtualPagename : 'forme|internet_leased_line|homepage', varLob: 'airtel_b2b' });
};

export const trackGTMSelectedPlan = (feasibilityStatus, bandwidth) => {
  dataLayer.push({
    event: 'SPAPV',
    virtualPagename: 'forme|internet_leased_line|thankyou',
    leadFeasibilityScore: `${feasibilityStatus}`,
    planDetails: bandwidth,
    varLob: 'airtel_b2b'
  });
};
